import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';

import { Page, WmSection } from 'services/wm/wm.types';

import { WeightManagementState } from './wm.types';

const initialState: WeightManagementState = {
  pages: [],
  sections: []
};

const wmSlice = createSlice({
  initialState,
  name: 'wm',
  reducers: {
    setPages: (state, action: PayloadAction<Page[]>) => {
      state.pages = action.payload;
    },
    setSections: (state, action: PayloadAction<WmSection[]>) => {
      state.sections = action.payload;
    }
  }
});

export const { setPages, setSections } = wmSlice.actions;

export const selectWmPages = (state: RootState) => state.wm.pages;
export const selectWmSections = (state: RootState) => state.wm.sections;

export default wmSlice.reducer;
